import { StackView, Tooltip, Icon, Text } from '@planningcenter/tapestry-react';
import React from 'react';
import { MessageStatus, useChatContext, useMessageContext, useTranslationContext, getReadByTooltipText, mapToUserNameOrId } from 'stream-chat-react';
import { top } from './../../../ext/@popperjs/core/lib/enums.js';

const SHARED_TOOLTIP_PROPS = {
    placement: top,
    popoverProps: {
        backgroundColor: "surface",
        color: "foreground",
        elevation: 2,
        offset: 0,
        paddingHorizontal: 1,
        paddingVertical: 1,
        radius: 6,
    },
};
const SHARED_LAYOUT_PROPS = {
    alignment: StackView.CENTER,
    axis: StackView.HORIZONTAL,
    distribution: StackView.CENTER,
    marginRight: 0.5,
    padding: 0.5,
    spacing: 0.5,
};
const CustomMessageStatus = () => {
    return (React.createElement(MessageStatus, { MessageReadStatus: CustomMessageReadStatus, MessageDeliveredStatus: CustomMessageDeliveredStatus }));
};
const CustomMessageDeliveredStatus = () => {
    return (React.createElement(Tooltip, { title: "Delivered", ...SHARED_TOOLTIP_PROPS },
        React.createElement(StackView, { ...SHARED_LAYOUT_PROPS },
            React.createElement(Icon, { name: "general.check" }))));
};
const CustomMessageReadStatus = () => {
    var _a;
    const { client } = useChatContext();
    const { readBy } = useMessageContext("MessageStatus");
    const { t } = useTranslationContext("MessageStatus");
    const tooltipTitle = getReadByTooltipText(readBy, t, client, mapToUserNameOrId);
    const justReadByMe = (readBy === null || readBy === undefined ? undefined : readBy.length) === 1 && readBy[0].id === ((_a = client.user) === null || _a === undefined ? undefined : _a.id);
    const deliveredAndRead = !!((readBy === null || readBy === undefined ? undefined : readBy.length) && !justReadByMe);
    const readersWithoutOwnUser = deliveredAndRead
        ? readBy.filter((item) => { var _a; return item.id !== ((_a = client.user) === null || _a === undefined ? undefined : _a.id); })
        : [];
    const readByCount = readersWithoutOwnUser.length;
    return (React.createElement(Tooltip, { title: tooltipTitle, ...SHARED_TOOLTIP_PROPS },
        React.createElement(StackView, { ...SHARED_LAYOUT_PROPS },
            React.createElement(Text, { size: 5, color: "foregroundSecondary", shrink: 0, userSelect: "none" }, readByCount),
            React.createElement(Icon, { name: "general.checkDouble", size: "lg" }))));
};

export { CustomMessageStatus };
//# sourceMappingURL=custom_message_status.js.map
